import { request, getJSON } from "./request";
import { resolveDownloadConfigFileName } from "./download-config";
export const getUserInfo = () => {
  return request(`/v1/user`, "get", { params: { is_teacher: true } });
};
// 发送验证码
export const sendCode = (params) => {
  return request("/v1/auth/sendCode", "post", { json: params });
};
export const authLogout = (params) => {
  return request("/v1/auth/logout", "post", { json: params });
};
export const weChatShare = (params) => {
  return request(`/v1/wechat/share`, "get", { params });
};

export const getDownloadConfig = (params) => {
  const fileName = resolveDownloadConfigFileName();
  return getJSON(`${process.env.VUE_APP_CDN_URL}/cdn/saas-desktop/${fileName}`);
};

export const getAndroidAppVersion = (params) => {
  return request(`/v1/appVersion/get/android`, "get", { params });
};
export const getIosAppVersion = (params) => {
  return request(`/v1/appVersion/get/ios`, "get", { params });
};
